export default function getLoginUser() {
  return window?.$dt?.objLoginUser || {};
}
